export function throwValidatorNotImplemented<TCommand, TContext>(command: TCommand, ctx: TContext): boolean {
  throw new Error('Not implemented');
}
